module.exports = __webpack_public_path__ + "static/media/companies.f897a40c.svg";